import { Loader2 } from "lucide-react";
import type { FC } from "react";

import { AgentMoodAvatar } from "@/features/agents/components/AgentMoodAvatar";
import { cn } from "@/lib/utils";

import {
  SIGNAL_META,
  signalFace,
  signalTone,
  TONE_CLASSES
} from "../signalTone";
import type { AttentionItem } from "../types";

/**
 * The agent's face with the kind badge at its corner, in the signal's colour
 * (or a grey spinner for a running agent). Banners and menu rows share it.
 */
export const SignalFace: FC<{
  seed: string;
  item?: Pick<AttentionItem, "kind" | "issues">;
  running?: boolean;
  size?: "row" | "banner";
}> = ({ seed, item, running, size = "banner" }) => {
  const face = size === "banner" ? "size-7 rounded-lg" : "size-6 rounded-md";
  const Icon = item ? SIGNAL_META[signalFace(item)].icon : null;
  return (
    <span className="relative shrink-0">
      <AgentMoodAvatar agent={{ key: seed }} className={face} />
      {Icon || running ? (
        <span
          className={cn(
            "absolute -right-1 -bottom-1 flex size-3.5 items-center justify-center rounded-full bg-white/95 shadow-sm dark:bg-zinc-800/95",
            item ? TONE_CLASSES[signalTone(item)].text : "text-muted-foreground"
          )}
        >
          {Icon ? (
            <Icon className="size-2.5" strokeWidth={2.5} />
          ) : (
            <Loader2 className="size-2.5 animate-spin" />
          )}
        </span>
      ) : null}
    </span>
  );
};
